/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth__Reset_Password__TitleInputs */

const en_auth__reset_password__title = /** @type {(inputs: Auth__Reset_Password__TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset password`)
};

/**
* | output |
* | --- |
* | "Reset password" |
*
* @param {Auth__Reset_Password__TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth__reset_password__title = /** @type {((inputs?: Auth__Reset_Password__TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth__Reset_Password__TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth__reset_password__title(inputs)
});